export default __webpack_public_path__ + "static/media/discovery.ee34730c.svg";